"use client";

import type { ReactNode } from "react";

import { MobileTabBar } from "@/components/mobile/mobile-tab-bar";

export type MobileShellProps = {
  readonly children: ReactNode;
  /** When true, skip the mobile tab bar (e.g. pseudo-org redirect routes). */
  readonly disabled?: boolean;
};

/**
 * Org main-area wrapper: desktop unchanged; below `md`, content sits above a bottom tab bar.
 */
export function MobileShell({
  children,
  disabled = false,
}: MobileShellProps): JSX.Element {
  if (disabled) {
    return <>{children}</>;
  }

  return (
    <div className="flex h-full min-h-0 w-full min-w-0 flex-col overflow-x-hidden">
      <div className="min-h-0 min-w-0 flex-1 overflow-hidden">{children}</div>
      {/* overflow-visible so the center Ask Kriya FAB can sit above the bar */}
      <div className="relative z-40 shrink-0 overflow-visible md:hidden">
        <MobileTabBar />
      </div>
    </div>
  );
}
